import { useFeatureFlagEnabled } from "posthog-js/react";

/**
 * Hook to check if WIP report card metrics should be displayed
 */
export function useWipReportCardMetricsEnabled(): boolean {
  return useFeatureFlagEnabled("wip-report-card-metrics-enabled") ?? false;
}

/**
 * Hook to check if touchpoint ID should be shown in the sidebar
 * Defaults to true in development environment
 */
export function useTouchpointIdSidebarEnabled(): boolean {
  return useFeatureFlagEnabled("show-touchpoint-id-sidebar") ?? true;
}

/**
 * Hook to check if deep research reports should be enabled
 */
export function useDeepResearchEnabled(): boolean {
  return useFeatureFlagEnabled("deep-research-enabled") ?? false;
}

/**
 * Hook to check if mini apps / reports should be visible
 */
export function useMiniAppsVisibility(): boolean {
  return useFeatureFlagEnabled("mini-apps-visibility") ?? false;
}

/**
 * Hook to check if the user has admin review permissions for deep research reports
 */
export function useDRRAdminReview(): boolean {
  return useFeatureFlagEnabled("deep-research-admin-review") ?? false;
}

/**
 * Hook to check if custom channels should be visible
 * Only available for ServiceTitan customers or internal staff (managed by PostHog)
 */
export function useCustomChannelsVisibility(): boolean {
  return useFeatureFlagEnabled("custom-channels-visibility") ?? false;
}

/**
 * Hook to check if custom channels rules management should be enabled
 */
export function useCustomChannelsRulesManagementEnabled(): boolean {
  return useFeatureFlagEnabled("custom-channels-rules-management") ?? false;
}
